import { Button, ButtonLevel, type ButtonProps, type PressEvent } from '@vizit/atoms';
import { XCloseIcon } from '@vizit/icons';
import { cva, cx } from '@vizit/theme';
import * as React from 'react';
import { ComboBoxStateContext } from 'react-aria-components';

const classes = cva({
  variants: {
    hasValue: {
      true: 'visible',
      false: 'invisible',
    },
  },
});

function ComboboxClearButton(props: ButtonProps) {
  const { className, children, onPress, ...other } = props;

  const state = React.useContext(ComboBoxStateContext);

  const handlePress = React.useCallback(
    (event: PressEvent) => {
      state?.setSelectedKey(null);
      state?.setInputValue('');

      onPress?.(event);
    },
    [onPress, state],
  );

  return (
    <Button
      className={cx(
        'vzt-combobox__clear-button text-gray-utility-400 pl-0 pr-0',
        classes({ hasValue: !!state?.inputValue, className }),
      )}
      level={ButtonLevel['Text-Secondary']}
      onPress={handlePress}
      {...other}
    >
      <XCloseIcon size={16} aria-label="Clear" />
    </Button>
  );
}

export { ComboboxClearButton };
